export default "__VITE_ASSET__14de93d0__"